document.addEventListener(
    "DOMContentLoaded", () => {
        const mmenu = new Mmenu("#mmenu", {
            slidingSubmenus: false,
            navbar: {
                add: false
            },
            // options
            offCanvas: {
                position: "right-front"
            },
            navbars: [
                {
                    content: [
                        '<div class="mm-titlebar"></div>'
                    ]
                }
            ]
        }, {
            // configuration
            offCanvas: {
                page: {
                    nodetype: "section",
                    selector: ".page-wrapper"
                }
            },
            classNames: {
                fixedElements: {
                    fixed: "scroll-header"
                }
            }
        });

        const menuButton = document.querySelector('.menu-button');
        const menuAPI = mmenu.API;

        // instead of using click event and having to track whether the menu is open or not to change click behaviour simply change the href of the menu button to the ID of the page wrapper
        menuAPI.bind('open:after', function () {
            menuButton.setAttribute('href', '#pageTop');
        });

        menuAPI.bind('close:after', function () {
            menuButton.setAttribute('href', '#mmenu');
        });

        let dropdownMenuItems = document.querySelectorAll('.main-menu .trigger-ddl');
        dropdownMenuItems?.forEach(menuElem => menuElem.addEventListener('click', event => {
            var subNavigationElem = menuElem.nextElementSibling;
            if (subNavigationElem) {
                if (subNavigationElem.classList.contains('open')) {
                    menuElem.classList.remove('open');
                    subNavigationElem.classList.remove('open');
                } else {
                    document.querySelector('.main-menu .trigger-ddl.open')?.classList.remove('open');
                    document.querySelector('.sub-navigation.open')?.classList.remove('open');
                    menuElem.classList.add('open');
                    subNavigationElem.classList.add('open');
                }
            }
        }));

        let clostButtons = document.querySelectorAll('.sub-navigation-inner .btn-close');
        clostButtons?.forEach(closeElem => closeElem.addEventListener('click', event => {
            event.preventDefault();

            document.querySelector('.main-menu .trigger-ddl.open').classList.remove('open');
            document.querySelector('.sub-navigation.open').classList.remove('open');

            // after the menu has closed, reset the menu content to the default state
            setTimeout(() => {
                document.querySelector('.sub-nav-item ul.open')?.classList.remove('open');
                document.querySelector('.sub-nav-content-item.open')?.classList.remove('open');
                document.querySelector('.sub-nav-content-item.item-default')?.classList.add('open');
            }, 500);
        }));

        var timeout, currentLink, currentContent;

        let subMenuLinks = document.querySelectorAll('.sub-nav-item');
        subMenuLinks?.forEach(subMenuLink => {

            var menuItemKey = subMenuLink.dataset.itemId;

            var contentItemElem = document.querySelector('.sub-nav-content-item[data-item-id="' + menuItemKey + '"]');

            subMenuLink.querySelector('.sub-nav-item-title span')?.addEventListener('mouseenter', event => {
                // clear the timeout that shows the default content item as we don't need it is we've hovered another item
                clearTimeout(timeout);

                document.querySelector('.sub-nav-item.open')?.classList.remove('open');
                subMenuLink.classList.add('open');

                if (contentItemElem) {

                    if (!contentItemElem.classList.contains('open')) {
                        currentContent = contentItemElem;

                        document.querySelector('.sub-nav-content-item.open')?.classList.remove('open');
                        contentItemElem.classList.add('open');
                    }

                    var itemAnchorBoxTop = subMenuLink.getBoundingClientRect();
                    var itemAnchorBoxBottom = subMenuLink.querySelector('ul')?.getBoundingClientRect();
                    var contentItemBox = contentItemElem.getBoundingClientRect();

                    var menuElemSvg = subMenuLink.querySelector('svg');

                    menuElemSvg.querySelector('path').setAttribute('d', `
                    M ${itemAnchorBoxTop.x} ${itemAnchorBoxTop.y}
                    Q ${contentItemBox.x} ${itemAnchorBoxTop.y}, ${contentItemBox.x} ${contentItemBox.y}
                    V ${contentItemBox.y} ${contentItemBox.y + contentItemBox.height}
                    Q ${contentItemBox.x} ${itemAnchorBoxBottom.y + itemAnchorBoxBottom.height}, ${itemAnchorBoxBottom.x} ${itemAnchorBoxBottom.y + itemAnchorBoxBottom.height}
                    H ${itemAnchorBoxBottom.x + itemAnchorBoxBottom.width}
                    V ${itemAnchorBoxTop.y}
                    Z`);
                }

                currentLink = subMenuLink;

                document.addEventListener('mousemove', checkPosition);
            });

            subMenuLink.addEventListener('mouseleave', event => {
                document.removeEventListener('mousemove', onmousemove);
            });

            function checkPosition(event) {
                var movingOver = event.target.closest('.sub-nav-item');

                // if we are not over the sub nav item
                if (!movingOver) {
                    movingOver = event.target.closest('.sub-nav-content-item.open');
                    // and we are not over the content item
                    if (!movingOver) {
                        // check whether the hover link or the content item we have open is being hovered over (i.e. contains mouse cursor)
                        if ((currentLink && !currentLink.contains(event.target)) || (currentContent && !currentContent.contains(event.target))) {
                            currentLink.classList.remove('open');
                            currentContent?.classList.remove('open');

                            currentLink = null;
                            currentContent = null;

                            timeout = setTimeout(() => {
                                document.querySelector('.sub-nav-content-item.item-default')?.classList.add('open');
                            }, 500);
                        }

                        return;
                    }
                }
            }
        });
                
    }
);

var anchorlinks = document.querySelectorAll('a[href^="#"]');
anchorlinks.forEach(el => el.addEventListener('click', event => {
    event.preventDefault();

    var elementValue = el.getAttribute('href');
    if (elementValue != '#') {
        elementValue = elementValue.replace('#', '');
        var scrollElement = document.getElementById(elementValue);
        scrollElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
}));

let prevScrollPos = window.scrollY;
let scrollPos = window.scrollY;
const headerDesktop = document.querySelector(".desktop-header");
const headerMobile = document.querySelector(".mobile-header");
const scrollSwitch = 80;

window.addEventListener(
    'scroll', () => {
        scrollPos = window.scrollY;
        
        if (scrollPos >= scrollSwitch && prevScrollPos >= scrollPos) {
            headerDesktop.classList.add('scrolled');
            headerMobile.classList.add('scrolled');
        }
        else {
            headerDesktop.classList.remove('scrolled');
            headerMobile.classList.remove('scrolled');
        }

        prevScrollPos = scrollPos;
    }
);

